/**
 * File: tutorialTypes.ts
 * Path: apps/admin/src/shared/utils/tutorialTypes.ts
 * Description: The shape of a tutorial and the selectors every tutorial file shares.
 */

export const TOUR_TEXT_LIMIT = 300;

export interface TourStep {
  /** The page the step is on; the tutorial opens it first when you are elsewhere. */
  path?: string;
  /** CSS selector of the thing to light up. */
  target: string;
  title: string;
  text: string;
}

export interface Tutorial {
  id: string;
  /** A task, verb first: "Send an invoice". */
  title: string;
  /** A few words on what it covers or how long it is. */
  hint: string;
  /** Every page it belongs to: a path, or a pattern such as "/leads/:id". */
  pages: string[];
  /** The heading it sits under in the Help dialog and on the How to page. */
  group: string;
  /** The Guide card (guideContentData.ts) this tutorial belongs to, if any. */
  guideId?: string;
  steps: TourStep[];
}

/** The page's own heading, selectable on any page. */
export const HEAD = "main h1";

/** The buttons in a page header (its main action). */
export const PAGE_ACTIONS = '[data-tour="page-actions"]';
